import React, { useState } from "react";
import "./Add_offcanvas.css";
import Select from "react-select";
import { Button, Form, Offcanvas } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Blue_btn from "../../../../../../../common_components/common_btn/blue_btn/Blue_btn";
import Blue_border_button from "../../../../../../../common_components/common_btn/blue_border_button/Blue_border_button";
import Success_modal from "../../../../../../../common_components/common_modal/success_modal/Success_modal";
import successAnimation from "../../../../../../../animation/success_lottie/Success_lottie.json";
import classNames from "classnames";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import {
  Create,
  GetAll,
} from "../../../../../../../../features/admin/website/home/SuccessSpeaks/slice";
import { IDS } from "../../../../../../../../utils/IDS";

function Add_offcanvas({
  setShow,
  setSuccess,
  setErr,
  setShowError,
  defaultValues,
  showError,
  show,
  handleClose,
  setShowRejectModal,
}) {
  const {
    register,
    handleSubmit,
    reset,
    watch,
    getValues,
    formState: { errors },
  } = useForm({ defaultValues });
  const dispatch = useDispatch();

  const ImageFile = watch("image");

  const [modalSuccessShow, setModalsuccessShow] = useState(false);

  // const onSubmit = async (data) => {
  //   try {
  //     const res = await dispatch(Create(data));
  //     if (res.meta?.requestStatus === "fulfilled") {
  //       dispatch(GetAll());
  //       setShow(false);
  //       setSuccess(true);
  //     } else if (res.meta?.requestStatus === "rejected") {
  //       console.log(
  //         res.payload?.response?.data?.errors,
  //         "res.payload?.response?.data?.errors"
  //       );

  //       setShowError(res.payload?.response?.data?.errors);
  //     }
  //   } catch (error) {
  //     setShow(false);
  //     setErr(true);
  //     console.error(error);
  //   }
  // };

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();

      sendData.append("name", data?.name || "");
      sendData.append("description", data?.description || "");
      sendData.append("college", data?.college || "");
      sendData.append("country", data?.country || "");
      sendData.append("rating", data?.rating || "");

      if (data?.image && data.image.length > 0) {
        sendData.append("image", data.image[0]);
      }
      const res = await dispatch(Create(sendData));

      if (res.meta?.requestStatus === "fulfilled") {
        dispatch(GetAll());

        setModalsuccessShow(true); // SHOW SUCCESS MODAL

        reset(); // optional
        setShow(false); // close offcanvas
        setSuccess(true); // parent success flag (optional)
        setTimeout(() => {
          setModalsuccessShow(false);
        }, 3000);
      } else if (res.meta?.requestStatus === "rejected") {
        setShowError(res.payload?.response?.data?.errors);
        setShowRejectModal(true);
      }
    } catch (error) {
      setShow(false);
      setShowRejectModal(true);

      setErr(true);
      console.error(error);
    }
  };

  return (
    <>
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="end"
        className="view_application_canvas common_offcanvas"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Add</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="form_holder">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                <div className="col-md-4 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Name"
                      className={classNames("", { "is-invalid": errors?.name })}
                      {...register("name", {
                        required: "Name is required",
                        // maxLength: {
                        //   value: 100,
                        //   message: "Name cannot exceed 100 characters",
                        // },
                      })}
                    />
                    {errors?.name && (
                      <Form.Text className="text-danger">
                        {errors?.name?.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>
              </div>

              <div className="row">
                <div className="col-md-4 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>College</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter College"
                      className={classNames("", { "is-invalid": errors?.name })}
                      {...register("college", {
                        required: "College is required",
                        // maxLength: {
                        //   value: 100,
                        //   message: "College cannot exceed 100 characters",
                        // },
                      })}
                    />
                    {errors?.college && (
                      <Form.Text className="text-danger">
                        {errors?.college?.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>
              </div>

              <div className="row">
                <div className="col-md-4 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Country</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Country"
                      className={classNames("", { "is-invalid": errors?.name })}
                      {...register("country", {
                        required: "Country is required",
                      })}
                    />
                    {errors?.country && (
                      <Form.Text className="text-danger">
                        {errors?.country?.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>
              </div>

              <div className="row">
                <div className="col-md-4 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Rating</Form.Label>

                    <Form.Control
                      type="number"
                      placeholder="Enter Rating"
                      min={1}
                      max={5}
                      step={1}
                      className={classNames("", {
                        "is-invalid": errors?.rating,
                      })}
                      onKeyDown={(e) => {
                        // 🚫 block invalid characters
                        if (["-", "e", "+", "."].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      {...register("rating", {
                        required: "Rating is required",
                        valueAsNumber: true,
                        min: {
                          value: 1,
                          message: "Rating must be at least 1",
                        },
                        max: {
                          value: 5,
                          message: "Rating cannot be more than 5",
                        },
                      })}
                    />

                    {errors?.rating && (
                      <Form.Text className="text-danger">
                        {errors?.rating.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>
              </div>

              <div className="row">
                <div className="col-md-4 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Description"
                      className={classNames("", { "is-invalid": errors?.name })}
                      {...register("description", {
                        required: "Description is required",
                      })}
                    />
                    {errors?.description && (
                      <Form.Text className="text-danger">
                        {errors?.description?.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>
              </div>

              <div className="col-md-4 mb-3">
                <Form.Group className="form_field"></Form.Group>
                <Form.Label>Image</Form.Label>
                <Form.Control
                  className={classNames("", {
                    "is-invalid": errors?.image,
                  })}
                  type="file"
                  {...register("image", {
                    required: "Image is required",
                    validate: async (value) => {
                      // if (typeof value !== "string") {
                      //   const fileTypes = ["jpg", "png", "jpeg"];
                      //   const fileType = value[0].name?.split(".")[1];
                      //   if (!fileTypes.includes(fileType)) {
                      //     return `please upload a valid file format. (${fileTypes})`;
                      //   }
                      // }
                    },
                  })}
                  accept=".jpg, .jpeg, .png"
                />
                {errors.image && (
                  <span className="text-danger">{errors.image.message}</span>
                )}
              </div>

              <div className="col-md-4 mb-3">
                <Form.Group className="mb-3">
                  <Form.Label className="text-center">Logo Preview</Form.Label>
                  {typeof getValues("image") == "string" ? (
                    <div className="image-preview-container">
                      <img
                        src={IDS.IMG_URL + getValues("image")}
                        alt="Preview"
                        className="image-preview"
                        style={{ width: "150px", height: "130px" }}
                      />
                    </div>
                  ) : (
                    ImageFile &&
                    ImageFile?.length > 0 && (
                      <div className="image-preview-container">
                        <img
                          // src={URL.createObjectURL(getValues("image")[0])}
                          src={URL?.createObjectURL(ImageFile[0])}
                          alt="Preview"
                          className="image-preview"
                          style={{ width: "100px", height: "100px" }}
                        />
                      </div>
                    )
                  )}
                </Form.Group>
              </div>

              <div className="btn_holder">
                {/* <Blue_btn btn_text={"Cancle"} /> */}
                <Blue_border_button button_text={"Save"} type="submit" />
              </div>
            </Form>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Success_modal
        show={modalSuccessShow}
        onHide={() => setModalsuccessShow(false)}
        message_text={"Operation was successful!"}
        animationData={successAnimation}
      />
    </>
  );
}

export default Add_offcanvas;
